import { StyleSheet } from 'aphrodite'

import main from './main'
import table from './table'
import status from './status'

export default {
  main: StyleSheet.create(main),
  table: StyleSheet.create(table),
  status: StyleSheet.create(status)
}



// WEBPACK FOOTER //
// ./src/components/Transactions/style/index.js